
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    CHANGE_SIM_PROVIDER_GET_DEVICE_REQUEST,
    CHANGE_SIM_PROVIDER_REQUEST,
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { changeSimProviderGetDeviceResult, changeSimProviderResult } from 'Redux/actions';


function* getDevice({ payload }) {
    try {
        const QUERY = `
        query searchUnits ($conditions: [UnitSearchInput], $sort: [UnitSortInput], $limit: Int, $offset: Int) {
            result: searchUnits (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                items {
                    id
                    label
                    esn
                    imei
                    simCard {
                        iccId
                        msisdn
                        simProviderAccount {
                            id
                            name
                            simProviderId
                            simProvider {
                                id
                                name
                            }
                        }
                    }
                    deviceModel {
                        id
                        name
                        manufacturerId
                        manufacturer {
                            id
                            name
                        }
                    }
                }
                total
            }
        }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: {
                    fields: ["esn", "imei"],
                    terms: [payload],
                    exact: true
                },
                limit: 1,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(changeSimProviderGetDeviceResult(data?.result))
        } else {
            yield put(changeSimProviderGetDeviceResult({ error: true }))
        }

    } catch (exc) {
        yield put(changeSimProviderGetDeviceResult({ error: true }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/changeSimProvider/redux/saga",
            "getDevice",
        )
    }
}

function* updateSimProviderAccount({ payload }) {
    try {

        let QUERY = `
            mutation updateUnitsBatch ($unitIds: [Int]!, $features: UnitFeatureInput!, $simProviderAccountId: Int) {
                result: updateUnitsBatch (unitIds: $unitIds, features: $features, simProviderAccountId: $simProviderAccountId){
                    stepFunctionId
                    transactionId
                    transactionType
                    processStartDate
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );
        if (data?.result) {
            yield put(changeSimProviderResult({ updateSimprovider: data?.result }))
        } else {
            yield put(changeSimProviderResult({ updateSimprovider: false }))
        }

    } catch (exc) {
        yield put(changeSimProviderResult({ updateSimprovider: false }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/changeSimProvider/redux/saga",
            "updateSimProviderAccount",
        )
    }
}

function* watchMethods() {
    yield takeEvery(CHANGE_SIM_PROVIDER_GET_DEVICE_REQUEST, getDevice);
    yield takeEvery(CHANGE_SIM_PROVIDER_REQUEST, updateSimProviderAccount);
}



export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}